import React, { useState, useEffect } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";

import * as crud from "../operations";
import { ClientEditModal, ClienDeleteModal } from "../editModal";
import { ActionsColumnFormatter } from "../buttonsActions";

import { Link, useHistory, useParams } from "react-router-dom";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import axios from "axios";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { optionsFactory } from "../../../helper/table";

import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";

export const CompetionTable = (props) => {
    const { user } = useSelector(state => state.auth);
    const userDocument = user.uid ? user : user.payload
    const history = useHistory()
    const {uid} = useParams()


  
    const { addToast } = useToasts()
    const [documents, setDocuments] = useState([]);
    const [edit_show, setEditShow] = useState(false);
    const [delete_show, setDeleteShow] = useState(false);
    const [queryng, setQuery] = useState(true)
  
    const [filter, setFilter] = useState("");

    
  
    const [activeClient, setActiveClient] = useState({});
    useEffect(() => {
      const fetchData = async () => {
        const [
          documents_query,
        ] = await Promise.all([
          crud.getCompetition(uid),
        ])
        const products = documents_query.data.payload
  
        setDocuments(products)
        setQuery(false)
  
      }
      fetchData()
    }, [userDocument.company_id]);
    const modal = {
      controllers: props.controllers,
      show: edit_show,
      delete: delete_show,
      client: activeClient,
      handleClose: () => setEditShow(false),
      handleShow: () => setEditShow(true),
      hideDelete: () => setDeleteShow(!delete_show),
  
      handleDelete: (uid) => {
        crud
          .getClient(uid)
          .then((res) => {
            const client = res.data.payload;
            setActiveClient(client);
            setDeleteShow(true);
          })
          .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
              console.log(`request cancelled:${thrown.message}`)
            } else {
              console.log('another error happened')
            }
          })
      },
      deleteClient: (uid) => {
        crud.deleteClient(uid).then(() => {
          crud.getClients(setDocuments);
          addToast(process.env["REACT_APP_DELETE"], { appearance: 'success' });
  
  
          setDeleteShow(!delete_show);
        }).catch(err => {
          addToast(process.env["REACT_APP_NO_DELETE"], { appearance: 'error' });
        })
      },
      update: (client) => {
        crud.updateClient(client).then(() => {
          crud.getClients(setDocuments);
          addToast(process.env[`REACT_APP_${(client.uid ? "update" : "create").toUpperCase()}`], { appearance: 'success' });
  
          setEditShow(!edit_show);
        }).catch(err => {
          addToast(process.env[`REACT_APP_${(client.uid ? "no_update" : "no_create").toUpperCase()}`], { appearance: 'error' });
  
  
        })
      },
      openEdit: (uid) => {
        if (uid) {
          history.push({
            pathname: `/products/${uid}/competition/new`
          })
        } else {
          history.push({
            pathname: `/products/${uid}`
          })
        }
      },
    };
  
    if (!crud.columns.filter((col) => col.dataField === "action").length) {
      crud.columns.push({
        dataField: "action",
        text: "Actions",
        formatter: ActionsColumnFormatter,
        formatExtraData: modal,
        classes: "text-right pr-0",
        headerClasses: "text-right pr-3",
        style: {
          minWidth: "100px",
        },
      });
    }
    const fields = ["name", "description", "category", "volume", "metric"]
    const data = documents
      .map(doc => {
        return {
          ...doc,
          cost: "$" + Number(doc.cost).toFixed(2),
          srp: "$" + Number(doc.price).toFixed(2),
          "volume/metric": doc.volume + " " + doc.metric
        }
      })
      .filter(row => row.client === userDocument.company_id)
      .filter((data) => {
        for (const field of fields) {
          const string = String(data[field] ?? "")
          const value = string.toUpperCase();
          if (value.indexOf(filter.toUpperCase()) >= 0) {
            return true;
          }
        }
        return false;
      })
    const options = optionsFactory(data)
    // const totalizer_cols = ["cost", "price", "available", "reserved"]
    // const money_cols = ["cost", "price"]
    const cols = crud.columns
  return (
    <ToolkitProvider
    keyField="uid"
    data={data.map((doc, i) => ({ count: Number(i) + 1, ...doc }))}
    columns={cols}
    exportCSV={true}
    >
      {(toolkit) => (
        <>
          <div
            className="mt-20 content d-flex flex-column flex-column-fluid"
            id="kt_content"
          >
            
            <div className="card card-custom gutter-b">
              <div className="card-header d-flex justify-content-between">
                <h5 className="mt-7 card-label">Competition Product List</h5>

                <div className="card-toolbar">
                  <div className="card mx-2">
                  </div>

                  <Link
                    to={`/products/${uid}/competition/new`}
                    className="btn btn-primary font-weight-bolder new-product-ref"
                  >
                    <span className="svg-icon svg-icon-md">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Design/Flatten.svg"
                        )}
                      />
                    </span>
                    New Competion Product
                  </Link>
                </div>
              </div>

              <div className="card-body">
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  bordered={false}
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="uid"
                  {...toolkit.baseProps}
                  loading={queryng}
                  pagination={paginationFactory(options)}
                  overlay={overlayFactory({ spinner: true })}
                  noDataIndication={<div className="mr-2 text-muted">No records found</div>}
                ></BootstrapTable>
              </div>
            </div>
          </div>
        </>
      )}
    </ToolkitProvider>
  );
};
